<template>
    <div>

        <div class="panel panel-info">

            <div class="panel-heading">
                <i class="fa fa-barcode" aria-hidden="true"></i> BOLETOS DO CLIENTE
            </div>

            <div class="panel-body" >

                <table id="mytable" class="table table-bordred table-striped">

                    <thead>
                        <tr>
                            <th>TEXTO</th>
                            <th style="text-align: right;width: 120px">VALOR</th>
                            <th style="text-align: center;width: 120px">NÚMERO</th>
                            <th style="text-align: center;width: 120px">USUÁRIO</th>
                            <th style="text-align: center;width: 80px">ACOES</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr v-for="r in contratos" v-bind:key="r._id">
                            <td style="vertical-align: middle">{{ r.status_boleto }}</td>
                            <td style="vertical-align: middle;text-align: right;">R$ {{ r.valor.toFixed(2) }}</td>
                            <td style="text-align: center; vertical-align: middle">{{ r.seu_numero }}</td>
                            <td style="text-align: center; vertical-align: middle">{{ r.data_vencimento | date('DD/MM/YYYY') }}</td>
                            <td>
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn btn-xs btn-default dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        AÇÃO <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <a @click="sendEmail(r.id_boletos)">
                                                <i class="fa fa-envelope-o" aria-hidden="true"></i> ENVIAR EMAIL
                                            </a>
                                        </li>
                                        <li>
                                            <a @click="sendSms(r.id_boletos)">
                                                <i class="fa fa-commenting" aria-hidden="true"></i> ENVIAR SMS
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>

                    </tbody>

                </table>

                <br/><br/>

                <button :disabled="disabled" @click.prevent="liberar()" class="btn btn-success" v-if="contratos.length">
                    LIBERAR O CLIENTE POR 5 DIAS
                </button> &nbsp;&nbsp;

                <button :disabled="disabled" @click.prevent="verificar()" class="btn btn-info" v-if="contratos.length">
                    CHECAR PAGAMENTOS
                </button>


            </div>

        </div>
    </div>
</template>
<script>
/* global swal */
import { Contratos } from "../../class/index";
import { date } from "../../filters";

export default {
    filters: {
        date
    },
    props: {
        ref_id: {
            default: null
        }
    },
    data() {
        return {
            contratos: [],
            user: null,
            disabled: false
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    mounted() {
        this.loadComandos();
    },
    methods: {
        loadComandos() {
            Contratos.boletosCaControl(this.ref_id)
                .then(rows => (this.contratos = rows))
                .catch(err => console.log(err));
        },
        async liberar() {
            try {
                await Contratos.liberar5Dias(this.ref_id);
                swal(
                    "Desbloqueado!",
                    "Cliente desbloqueado por 5 dias!",
                    "success"
                );
            } catch (e) {
                console.error(e);
                if (e.response && e.response.status === 402) {
                    swal("Desbloqueado!", e.response.data.error, "error");
                }
            }
        },
        async sendSms(idBoleto) {
            try {
                this.disabled = true;
                await Contratos.boletosCaControlSMS(idBoleto);
                this.disabled = false;
            } catch (err) {
                console.error(err);
            }
        },

        verificar() {
            swal.queue([
                {
                    title: "FINANCEIRO",
                    confirmButtonText: "Verificar",
                    text: "Verificar os pagamentos?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return Contratos.checarRecebimento(this.ref_id)
                            .then(() => this.loadComandos())
                            .catch(err => console.error(err));
                    }
                }
            ]);
        },
        sendEmail(idBoleto) {
            Contratos.boletosCaControlEmail(idBoleto)
                .then(() => {
                    swal(
                        "Enviado!",
                        "O Boleto foi enviado por EMAIL!",
                        "success"
                    );
                })
                .catch(err => console.log(err));
        }
    }
};
</script>
